function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-9 -9)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  stroke: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.916 21.409H9.39v-8.142h2.525zm-1.245-9.245c-.818 0-1.458-.64-1.458-1.457 0-.818.64-1.458 1.458-1.458s1.458.64 1.458 1.458c0 .782-.64 1.457-1.458 1.457zm10.738 9.245h-2.525v-3.947c0-.96 0-2.169-1.315-2.169-1.316 0-1.529 1.031-1.529 2.098v4.018h-2.524v-8.142h2.417v1.102h.036c.32-.64 1.173-1.316 2.382-1.316 2.56 0 3.022 1.671 3.022 3.876v4.48h.036z",
  fill: "#000",
  fillRule: "nonzero"
}));

function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkgLTkpIj4KICAgICAgICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgc3Ryb2tlPSIjMDAwIi8+CiAgICAgICAgPGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTExLjkxNiAyMS40MDlIOS4zOXYtOC4xNDJoMi41MjV6TTEwLjY3MSAxMi4xNjRjLS44MTggMC0xLjQ1OC0uNjQtMS40NTgtMS40NTcgMC0uODE4LjY0LTEuNDU4IDEuNDU4LTEuNDU4czEuNDU4LjY0IDEuNDU4IDEuNDU4YzAgLjc4Mi0uNjQgMS40NTctMS40NTggMS40NTd6TTIxLjQwOSAyMS40MDloLTIuNTI1di0zLjk0N2MwLS45NiAwLTIuMTY5LTEuMzE1LTIuMTY5LTEuMzE2IDAtMS41MjkgMS4wMzEtMS41MjkgMi4wOTh2NC4wMThoLTIuNTI0di04LjE0MmgyLjQxN3YxLjEwMmguMDM2Yy4zMi0uNjQgMS4xNzMtMS4zMTYgMi4zODItMS4zMTYgMi41NiAwIDMuMDIyIDEuNjcxIDMuMDIyIDMuODc2djQuNDhoLjAzNnoiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgLinkedIn as ReactComponent };